export enum EEventTicketNameCheckResponse {
    FOUND = 'found',
    NOT_FOUND = 'not_found'
}
